import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetStockDataResponse = {
  isFaulted: boolean;
  isSuccess: boolean;
  state: number;
  exception: unknown;
  value: string | null;
};

type QueryType = {
  marca: string;
  numero: string;
};

export const getStockContainerData = async (
  query: QueryType
): Promise<string | null> => {
  try {
    const res = await apiClient.post<GetStockDataResponse>(
      Endpoints.StockNumber,
      query
    );
    return res.data.value || '';
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
